var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNominal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0316 0C26.0316 5.78995 30.7268 10.4805 36.512 10.4806V13.5196C30.77 13.5196 26.1036 18.1381 26.0316 23.8656V24H22.9877C22.9876 18.2101 18.2971 13.5196 12.5071 13.5196H0.5V10.4806H12.5071C18.2923 10.4806 22.9877 5.78517 22.9877 0H26.0316ZM24.5097 6.53382C23.2566 9.38559 21.8883 10.7491 19.0366 12.007C21.8883 13.2648 23.2566 14.6283 24.5097 17.4801C25.7675 14.6283 27.1309 13.2648 29.9827 12.007C27.1309 10.7539 25.7675 9.38556 24.5097 6.53382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNominal);
export default __webpack_public_path__ + "static/media/nominal.10a262cd4b7b9d9c2750344ee4430388.svg";
export { ForwardRef as ReactComponent };